/******/ (() => { // webpackBootstrap
/*!*******************************************!*\
  !*** ./src/js/product-recently-viewed.js ***!
  \*******************************************/
/*
BG: Uses localStorage to store the products the user visits, and displays it back to the customer in a recently viewed section.
*/
var recentlyViewedProducts = function recentlyViewedProducts() {
  var recentlyViewed = document.querySelector('.js-recently-viewed-products');
  var maxProducts = 6;
  var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts"));
  //by default, we assume the prodict array is empty. 
  var productArray = [];
  var flickityPresent = false;

  //We planning on using flickity?, we check to see if the inline attribute is present.
  if (recentlyViewed.hasAttribute('data-flickity')) {
    flickityPresent = true;
  }

  //if localstorage exists, retrieve the list and output it
  if (savedRecentProducts) {
    //BG: if array is greater than the maxProducts, then delete the first item in the array
    if (savedRecentProducts.length > maxProducts) {
      savedRecentProducts.shift();
    }
    //update the product array to be the array stored in localStorage.
    productArray = savedRecentProducts;
    if (productArray.length >= 3) {
      recentlyViewed.parentNode.classList.remove('hidden');
    }
    productArray.forEach(function (productHandle, index) {
      //console.log(window.Shopify.routes.root + `products/${productHandle}?view=card`);
      //using that productHandle, get the product markup.
      fetch(window.Shopify.routes.root + "products/".concat(productHandle, "?view=card")).then(function (response) {
        return response.text();
      }).then(function (html) {
        //BG: we get the first 26 characters of the response, to check if we're returning what we expect (the card product template) if the product no longer exists, it will 404, so we will return markup we don't intend, therefore we check to see if the preview does include what we expect, if it does, we show it, if it doesn't we remove it from the array.
        var preview = html.slice(0, 26);
        if (preview.includes("product-card")) {
          var flickitySlider = recentlyViewed.querySelector('.flickity-slider');
          if (!!flickitySlider) {
            flickitySlider.innerHTML += html;
          } else {
            recentlyViewed.innerHTML += html;
          }

          //if last product, and we're using flickity....
          if (index === productArray.length - 1 && flickityPresent && flickitySlider) {
            //after a breif delay, re-init flickity.
            setTimeout(function () {
              var flkty = Flickity.data('.js-recently-viewed-products');
              flkty.reloadCells();
              flkty.resize();
            }, 1000);
          }
        } else {
          //if the preview doesn't include the product card, we're not returning what we expect, remove it from the array.
          var removeProd = productArray.indexOf(productHandle);
          if (removeProd > -1) {
            productArray.splice(removeProd, 1);
          }

          //BG: Update localStorage, so we don't try and show it again.
          localStorage.setItem("recentProducts", JSON.stringify(productArray));
        }
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    });
  }
  // if the recently viewed section has the product handle, add this product to the array.
  if (recentlyViewed.hasAttribute('data-product-handle')) {
    var productHandle = recentlyViewed.getAttribute('data-product-handle');

    //BG: only add the product to the array, if it doesn't already exist
    if (productArray.indexOf(productHandle) == -1) {
      productArray.push(productHandle);
    }
    //BG: Update localStorage
    localStorage.setItem("recentProducts", JSON.stringify(productArray));
  }
};

//check if the section exists, if so, run the function.
if (!!document.querySelector('.js-recently-viewed-products')) {
  recentlyViewedProducts();
}
/******/ })()
;